import { useSyncExternalStore } from 'react'
import { getPracticeSnapshot, subscribePractice } from './engine'

/** The open practice session, or null; re-renders whenever it changes. */
export function usePracticeSession() {
  return useSyncExternalStore(
    (onChange) => {
      const unsubscribe = subscribePractice(onChange)
      return () => {
        unsubscribe()
      }
    },
    getPracticeSnapshot,
    () => null,
  )
}
